// ============================================================
// MOCK DATA — Comunidad matrum
// Este archivo centraliza TODOS los datos simulados.
// Al integrar el backend se reemplazará por llamadas a la API.
// ============================================================

export const BRAND = {
  name: "Lorena Cotano",
  role: "Matrona · Sexóloga",
  logo: "/images/logo.png",
  membershipPrice: 39,
  currency: "€",
};

export const STAGES = [
  {
    id: "embarazo",
    title: "Embarazo",
    subtitle: "Un tiempo de creación",
    description:
      "Acompañamiento consciente durante la gestación: cambios en tu cuerpo, preparación al parto y vínculo con tu bebé.",
    image: "/images/embarazo.png",
    color: "#D4A8B0",
  },
  {
    id: "puerperio",
    title: "Puerperio",
    subtitle: "El tiempo sagrado",
    description:
      "El puerperio es un tiempo sagrado de transformación. Cuidado emocional, lactancia y reencuentro contigo misma.",
    image: "/images/puerperio.png",
    color: "#C4705A",
  },
  {
    id: "menopausia",
    title: "Menopausia",
    subtitle: "Sabiduría y plenitud",
    description:
      "Una nueva etapa de poder femenino. Salud hormonal, sexualidad y bienestar para vivirla con plenitud.",
    image: "/images/menopausia.png",
    color: "#7A5C9E",
  },
];

// Artículos gratuitos (acceso público sin registro)
export const ARTICLES = [
  {
    id: "art-1",
    title: "Cómo preparar tu cuerpo y tu mente para el parto",
    stage: "embarazo",
    excerpt:
      "Claves prácticas para llegar al momento del nacimiento con confianza, información y calma.",
    cover: "/images/embarazo.png",
    author: "Lorena Cotano",
    date: "2025-06-12",
    readTime: 6,
    content:
      "El parto es uno de los momentos más transformadores en la vida de una mujer. Prepararlo desde el cuerpo y desde la mente marca una diferencia profunda en cómo lo vivimos.\n\nEn este artículo repasamos ejercicios de suelo pélvico, técnicas de respiración y herramientas emocionales para afrontar el nacimiento con serenidad.\n\nRecuerda: no existe un parto perfecto, existe tu parto. Y cada elección informada es un acto de amor hacia ti y hacia tu bebé.",
  },
  {
    id: "art-2",
    title: "Puerperio real: lo que nadie te cuenta",
    stage: "puerperio",
    excerpt:
      "Hablamos con honestidad y ternura sobre las emociones, el cuerpo y el descanso tras el nacimiento.",
    cover: "/images/puerperio.png",
    author: "Lorena Cotano",
    date: "2025-05-28",
    readTime: 8,
    content:
      "El puerperio es un tiempo sagrado de transformación. Acompañarte en este proceso, con honestidad y ternura, es mi forma de cuidar la maternidad desde dentro.\n\nHablemos de lo que casi nunca se nombra: la montaña rusa hormonal, la lactancia, la identidad que se reconstruye y la necesidad —no el capricho— de descansar y pedir ayuda.\n\nNo estás sola. Este proceso tiene sentido y merece cuidado.",
  },
  {
    id: "art-3",
    title: "Menopausia y sexualidad: derribando mitos",
    stage: "menopausia",
    excerpt:
      "La menopausia no es el final de nada. Es el comienzo de una etapa de sabiduría y plenitud.",
    cover: "/images/menopausia.png",
    author: "Lorena Cotano",
    date: "2025-05-10",
    readTime: 7,
    content:
      "Cada etapa transformadora de tu vida merece un espacio de escucha, cuidado y conocimiento.\n\nLa menopausia trae cambios reales en el cuerpo, pero también una oportunidad de reconectar con el deseo, la intimidad y el placer desde un lugar nuevo.\n\nEn este artículo abordamos la salud hormonal, la lubricación, la libido y cómo la comunicación en pareja puede abrir una etapa sexual más consciente y libre.",
  },
  {
    id: "art-4",
    title: "Suelo pélvico: tu gran aliado en cada etapa",
    stage: "embarazo",
    excerpt:
      "Por qué cuidar el suelo pélvico es fundamental durante el embarazo, el posparto y la madurez.",
    cover: "/images/etapas-grupo.png",
    author: "Lorena Cotano",
    date: "2025-04-22",
    readTime: 5,
    content:
      "El suelo pélvico sostiene mucho más de lo que imaginamos. Cuidarlo es cuidar tu salud íntima, tu postura y tu bienestar a largo plazo.\n\nDescubre ejercicios sencillos que puedes integrar en tu día a día en cualquier etapa de tu vida.",
  },
];

// Cursos (requieren membresía)
export const COURSES = [
  {
    id: "curso-1",
    title: "Preparación integral al parto",
    stage: "embarazo",
    lessons: 8,
    duration: "4 h 30 min",
    cover: "/images/embarazo.png",
    description:
      "Un recorrido completo para llegar al parto con información, herramientas y confianza.",
    modules: [
      "Fisiología del parto",
      "Respiración y relajación",
      "Posturas y movimiento",
      "Plan de parto",
    ],
  },
  {
    id: "curso-2",
    title: "Acompañar tu puerperio",
    stage: "puerperio",
    lessons: 6,
    duration: "3 h 10 min",
    cover: "/images/puerperio.png",
    description:
      "Cuidado emocional, lactancia y recuperación física en las primeras semanas.",
    modules: [
      "Los primeros días",
      "Lactancia sin culpa",
      "Recuperación del suelo pélvico",
      "Salud emocional",
    ],
  },
  {
    id: "curso-3",
    title: "Menopausia consciente",
    stage: "menopausia",
    lessons: 7,
    duration: "3 h 45 min",
    cover: "/images/menopausia.png",
    description:
      "Vive esta etapa con conocimiento, bienestar y una sexualidad plena.",
    modules: [
      "Cambios hormonales",
      "Sexualidad y deseo",
      "Alimentación y energía",
      "Bienestar emocional",
    ],
  },
];

// Sesiones grupales online (Zoom) — requieren membresía
export const SESSIONS = [
  {
    id: "ses-1",
    title: "Círculo de embarazadas",
    stage: "embarazo",
    date: "2025-07-18",
    time: "19:00",
    duration: "60 min",
    zoomLink: "https://zoom.us/j/000000001",
    description:
      "Un espacio íntimo para compartir dudas y vivencias del embarazo.",
  },
  {
    id: "ses-2",
    title: "Encuentro de puerperio",
    stage: "puerperio",
    date: "2025-07-25",
    time: "11:00",
    duration: "60 min",
    zoomLink: "https://zoom.us/j/000000002",
    description:
      "Sesión de acompañamiento emocional para madres recientes.",
  },
  {
    id: "ses-3",
    title: "Menopausia en comunidad",
    stage: "menopausia",
    date: "2025-08-02",
    time: "18:30",
    duration: "60 min",
    zoomLink: "https://zoom.us/j/000000003",
    description:
      "Compartimos herramientas para vivir la menopausia con plenitud.",
  },
];

// Foros de la comunidad — requieren membresía
export const FORUMS = [
  {
    id: "foro-embarazo",
    stage: "embarazo",
    title: "Embarazo",
    topics: 24,
    lastActivity: "hace 2 h",
    threads: [
      { id: "t1", title: "Miedos ante el primer parto", replies: 12, author: "María" },
      { id: "t2", title: "Náuseas en el primer trimestre", replies: 8, author: "Lucía" },
    ],
  },
  {
    id: "foro-puerperio",
    stage: "puerperio",
    title: "Puerperio",
    topics: 31,
    lastActivity: "hace 40 min",
    threads: [
      { id: "t3", title: "Lactancia dolorosa, ¿es normal?", replies: 19, author: "Ana" },
      { id: "t4", title: "Cómo pedir ayuda sin culpa", replies: 15, author: "Carmen" },
    ],
  },
  {
    id: "foro-menopausia",
    stage: "menopausia",
    title: "Menopausia",
    topics: 18,
    lastActivity: "hace 5 h",
    threads: [
      { id: "t5", title: "Sofocos nocturnos", replies: 22, author: "Rosa" },
      { id: "t6", title: "Retomar la intimidad en pareja", replies: 9, author: "Elena" },
    ],
  },
];

export const TESTIMONIALS = [
  {
    id: "tes-1",
    name: "Marta G.",
    stage: "Puerperio",
    text: "Encontrar esta comunidad fue un antes y un después. Me sentí acompañada y comprendida en el momento más vulnerable.",
  },
  {
    id: "tes-2",
    name: "Silvia R.",
    stage: "Embarazo",
    text: "Los cursos son claros y cercanos. Llegué al parto con muchísima más confianza gracias a Lorena.",
  },
  {
    id: "tes-3",
    name: "Pilar M.",
    stage: "Menopausia",
    text: "Por fin un espacio donde hablar de la menopausia sin tabúes. Me ha cambiado la forma de vivir esta etapa.",
  },
];

export const MEMBERSHIP_BENEFITS = [
  "Acceso a todos los cursos online",
  "Foros privados de la comunidad por etapa",
  "Sesiones grupales online mensuales por Zoom",
  "Contenido exclusivo cada semana",
  "Acompañamiento de Lorena y otras mujeres",
  "Cancela cuando quieras, sin permanencia",
];

// Credenciales demo para el modo mock
export const MOCK_ADMIN = {
  email: "lorena@lorenacotano.com",
  password: "admin123",
  name: "Lorena Cotano",
  role: "admin",
  isMember: true,
};
